import { render, staticRenderFns } from "./ChartColorTestModal.vue?vue&type=template&id=cda743dc&scoped=true"
import script from "./ChartColorTestModal.vue?vue&type=script&lang=js"
export * from "./ChartColorTestModal.vue?vue&type=script&lang=js"
import style0 from "./ChartColorTestModal.vue?vue&type=style&index=0&id=cda743dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda743dc",
  null
  
)

export default component.exports